import { render, staticRenderFns } from "./FormEditarFornecedor.vue?vue&type=template&id=035cd24d"
import script from "./FormEditarFornecedor.vue?vue&type=script&lang=js"
export * from "./FormEditarFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports